import configBase from './envs/config.base';
import { ParsedFalse } from '@whiz-cart/node-shared/models/parsed/parsedBoolean';
import { z } from 'zod';

export type ConfigBase = typeof configBase;

export const ConfigEnv = z.object({
    env: z.object({
        id: z.string(),
        name: z.string(),
        tier: z.string(),
        allowEnv: z.preprocess((s) => (typeof s === 'string' ? s.split(',') : s), z.string().array()),
        allowVersion: z.string(),
    }),
    backends: z.object({
        storeManager: z.string(),
        cashier: z.string(),
        devOps: z.string(),
        deployment: z.string(),
        config: z.string(),
        azureMonitoring: z.string(),
        mobileBackend: z.string(),
        search: z.string(),
        product: z.string(),
        storeAdmin: z.string(),
        dsi: z.string(),
        dataSync: z.string(),
        buildMonitor: z.string(),
        navigationService: z.string(),
        masterDataService: z.string(),
        marketingPlatform: z.string(),
    }),
    firebase: z.object({
        apiKey: z.string(),
        authDomain: z.string(),
        databaseURL: z.string(),
        projectId: z.string(),
        storageBucket: z.string(),
        messagingSenderId: z.string(),
        appId: z.string(),
        publicVapidKey: z.string(),
    }),
    turnstileCaptcha: z
        .object({
            siteKey: z.string().optional(),
        })
        .default({}),
    dsi: z.object({
        numberOfCachedEventsImages: z.number().optional(),
    }),
    showEnvColor: z.string().or(ParsedFalse),
    cdnUrl: z.string(),
    cdnToken: z.string(),
    brandImageUrl: z.string(),
    snapshotImageUrl: z.string(),
    supportInfoUrl: z.string(),
    promotionsUrl: z.string(),
    pluHierarchyUrl: z.string(),
    loginVideosUrl: z.string(),
    infoMaterialsUrl: z.string(),
    indexManagerUrl: z.string().optional(),
    appInsightsInstrumentationKey: z.string().nullish(),
    feature: z
        .object({
            manualShelfNumber: z.coerce.boolean().nullish(),
            logAnalyzer: z.coerce.boolean().nullish(),
            reporting: z.coerce.boolean().nullish(),
        })
        .default({}),
    couponimagesURL: z.string(),
    localazyCdn: z.string(),
    tracing: z
        .discriminatedUnion('type', [
            z.object({
                type: z.literal('appinsights'),
                key: z.string().nullish(),
            }),
            z.object({
                type: z.literal('grafana'),
                collector: z.string(),
            }),
        ])
        .nullish(),
    azureDevops: z
        .object({
            clientId: z.string(),
        })
        .default({
            clientId: 'a0d571bc-7228-4d3b-ac0c-a1fbf9f9b72b',
        }),
    forceUpdate: z.string().optional(),
});

export type ConfigEnv = z.infer<typeof ConfigEnv>;

export type Config = ConfigBase & ConfigEnv;
